module.exports = __webpack_public_path__ + "media/operational-planning_en_ipad_new.8e368f24.mp4";